module.exports = __webpack_public_path__ + "static/media/miscellaneous.a5d67288.png";